import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { HintText } from "./styles";
import PromoCodeInput from "./PromoCodeInput";

type PromoCodeType = {
  productId: string;
  setDiscount: (number: number) => void;
  classPrice: number;
  currency: string;
  hasFreeTrial: boolean;
  setValidReferralCodeMessage: (value: string) => void;
};

const PromoCode = ({
  productId,
  setDiscount,
  classPrice,
  currency,
  hasFreeTrial,
  setValidReferralCodeMessage,
}: PromoCodeType) => {
  const { t } = useTranslation("new_sign_up");
  const [inputVisible, setInputVisible] = useState<boolean>(true);
  const [status, setStatus] = useState(0);
  const havePromoCode = () => setStatus(1);
  // HANDLERS
  const hideInput = () => setInputVisible(false);
  const showInput = () => setInputVisible(true); // eslint-disable import/no-named-as-default
  return (
    <div style={{ textAlign: "left", marginBottom: 0, marginTop: 20 }}>
      {status === 0 ? (
        <HintText onClick={havePromoCode}>
          {t("Have a discount code?")}
        </HintText>
      ) : (
        <PromoCodeInput
          productId={productId}
          inputVisible={inputVisible}
          hideInput={hideInput}
          showInput={showInput}
          setDiscount={setDiscount}
          classPrice={classPrice}
          currency={currency}
          hasFreeTrial={hasFreeTrial}
          setValidReferralCodeMessage={setValidReferralCodeMessage}
        />
      )}
    </div>
  );
};

export default PromoCode;
